module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.form) ? _c('div', {
    staticClass: "mb-2"
  }, [(_vm.editable && _vm.creatable) ? _c('v-btn', {
    staticClass: "pink white--text",
    on: {
      "click": _vm.add
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v("\n      " + _vm._s(_vm.$t('crud.add')) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.serverside && _vm.refreshable) ? _c('v-btn', {
    staticClass: "blue darken-1 white--text button-refresh",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("refresh")])], 1) : _vm._e(), _vm._v(" "), (_vm.exportable) ? _c('v-btn', {
    staticClass: "blue darken-1 white--text",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.exportCsv
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("save")]), _vm._v("\n      " + _vm._s(_vm.$t('crud.csv')) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.filtering) ? _c('v-btn', {
    class: {
      blue: true, 'darken-1': true, 'white--text': true, 'button-active-filter': _vm.isAnyFilterActive()
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showFilters($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("filter")]), _vm._v("\n      " + _vm._s(_vm.$t('crud.filters')) + "\n    ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.form) ? _c('div', {
    staticClass: "table__overflow elevation-1"
  }, [_c('table', {
    staticClass: "datatable table table-crud"
  }, [_c('thead', [_c('tr', [(_vm.isBulkEnabled) ? _c('th', {
    staticClass: "check column"
  }, [_c('input', {
    ref: "checkAll",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.checkAll
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fieldKeys), function(field) {
    return (_vm.nFields[field].list) ? _c('th', {
      key: field,
      class: {
        sortable: _vm.nFields[field].sortable,
          column: true,
          'text-xs-center': _vm.nFields[field].type === 'bool',
          'text-xs-left': _vm.nFields[field].type !== 'bool',
      },
      on: {
        "click": function($event) {
          _vm.sort(field)
        }
      }
    }, [(_vm.isActiveFilter(field)) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: _vm.filterTooltip(field)
        }),
        expression: "{ content: filterTooltip(field) }"
      }],
      staticClass: "filter mr-1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showFilters($event)
        }
      }
    }, [_vm._v("filter_none")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.nFields[field].label) + "\n            "), _c('v-icon', {
      class: {
        sorted: _vm.sortBy === field
      }
    }, [_vm._v(_vm._s(_vm.sortAsc && _vm.sortBy === field ? 'arrow_downward' : 'arrow_upward'))])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.itemActions.length > 0 || _vm.editable || _vm.deletable) ? _c('th', {
    staticClass: "actions"
  }) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [_c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "100"
    }
  }, [_c('loadable', {
    attrs: {
      "loading": true,
      "description": _vm.$t('loadingItems')
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.items && _vm.items.length == 0),
      expression: "!loading && items && items.length == 0"
    }],
    staticClass: "no-items"
  }, [_c('td', {
    attrs: {
      "colspan": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('noItems')))])]), _vm._v(" "), (!_vm.loading) ? _vm._l((_vm.paginated), function(item, index) {
    return _c('tr', {
      key: item.id,
      staticClass: "column"
    }, [(_vm.isBulkEnabled) ? _c('td', {
      staticClass: "check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checked[item._self]),
        expression: "checked[item._self]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.checked[item._self]) ? _vm._i(_vm.checked[item._self], null) > -1 : (_vm.checked[item._self])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checked[item._self],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.checked, item._self, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.checked, item._self, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.checked, item._self, $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fieldKeys), function(field) {
      return (_vm.nFields[field].list) ? [_vm._t(field, [_c('crud-field', {
        key: ((item.id) + "-" + field),
        ref: "crudField",
        refInFor: true,
        attrs: {
          "field": field,
          "options": _vm.nFields[field],
          "editable": _vm.editable
        },
        on: {
          "save": _vm.save,
          "edited": _vm.edited
        },
        model: {
          value: (_vm.paginated[index]),
          callback: function($$v) {
            _vm.$set(_vm.paginated, index, $$v)
          },
          expression: "paginated[index]"
        }
      })], {
        item: item,
        field: field,
        value: item[field]
      })] : _vm._e()
    }), _vm._v(" "), (_vm.itemActions.length > 0 || _vm.editable || _vm.deletable) ? _c('td', {
      staticClass: "text-xs-right actions"
    }, [_c('div', {
      staticClass: "actions"
    }, [_vm._l((_vm.itemActions), function(action, index) {
      return (action.visibility(item)) ? _c('v-btn', {
        key: index,
        staticClass: "ma-0",
        attrs: {
          "icon": action.icon && !action.label,
          "flat": "",
          "variant": item.variant
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            action.click(item)
          }
        }
      }, [(action.icon) ? _c('v-icon', [_vm._v(_vm._s(action.icon))]) : _vm._e(), _vm._v(" "), (action.label) ? _c('span', [_vm._v(_vm._s(action.label))]) : _vm._e()], 1) : _vm._e()
    }), _vm._v(" "), (_vm.editable) ? _c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": "",
        "title": _vm.$t('crud.edit')
      },
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.deletable) ? _c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": "",
        "title": _vm.$t('crud.delete')
      },
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 2)]) : _vm._e()], 2)
  }) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.form && (_vm.bulk || _vm.paginating)) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', [_vm._l(((_vm.bulk && _vm.selectedItems.length > 0 ? _vm.bulkActions : [])), function(action, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "error": action.color === 'error'
      },
      on: {
        "click": function($event) {
          _vm.actionOnSelected(action)
        }
      }
    }, [(action.icon) ? _c('v-icon', {
      attrs: {
        "left": "",
        "dark": action.color === 'error'
      }
    }, [_vm._v(_vm._s(action.icon))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(action.multiLabel || action.label))])], 1)
  }), _vm._v(" "), (_vm.deletable && _vm.bulk && _vm.selectedItems.length > 0) ? _c('v-btn', {
    attrs: {
      "error": "",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("delete")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('crud.deleteSelected')))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.allItemsActions), function(action, index) {
    return _c('v-btn', {
      key: ("allItems_" + index),
      attrs: {
        "error": action.color === 'error'
      },
      on: {
        "click": function($event) {
          _vm.allItemsActionSelected(action)
        }
      }
    }, [(action.icon) ? _c('v-icon', {
      attrs: {
        "left": "",
        "dark": action.color === 'error'
      }
    }, [_vm._v(_vm._s(action.icon))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(action.multiLabel || action.label))])], 1)
  })], 2)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [(!_vm.serverside || _vm.total) ? _c('div', [(_vm.paginating) ? _c('v-pagination', {
    staticClass: "mt-2",
    attrs: {
      "length": Math.ceil(_vm.totalItems / _vm.perPage),
      "total-visible": "3"
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('crud-filter-dialog', {
    ref: "filterDialog",
    attrs: {
      "fields": _vm.nFields
    },
    on: {
      "saved": function($event) {
        _vm.saveFilters()
      },
      "cancel": function($event) {
        _vm.clearFilters()
      }
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  }), _vm._v(" "), (_vm.form && _vm.formComponent) ? _c(_vm.formComponent, {
    tag: "component",
    attrs: {
      "v-model": _vm.form,
      "fields": _vm.fields,
      "form-order": _vm.formOrder
    },
    on: {
      "save": _vm.formSave,
      "cancel": _vm.formCancel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form && !_vm.formComponent) ? _c('crud-form', {
    ref: "form",
    attrs: {
      "fields": _vm.nFields,
      "form-order": _vm.formOrder,
      "error": _vm.formError
    },
    on: {
      "save": _vm.formSave,
      "cancel": _vm.formCancel
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d926f5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Crud/Crud.vue
// module id = 1074
// module chunks = 1